import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { File } from './File'
import { AutoSizer, List } from 'react-virtualized'
import mediaViewItems from 'modules/Media/computed/mediaViewItems'
import { signal, state } from 'cerebral/tags'
import { Empty } from 'components/Common/Empty'
import { EmptyFolder } from 'components/Icons'
import { Scrollbars } from 'react-custom-scrollbars'
import { css } from 'aphrodite'
import styles from './styles'
import { Strip } from './Strip'
import Group from './group.js'
import { Loader } from 'components/App/Loader'
import { media } from 'consts'
import { ContextMenu } from './ContextMenu'

const listStyle = {
  overflowX: false,
  overflowY: false,
  outline: 'none',
  border: 'none',
  margin: 0
}

const pruneGroupForState = group => {
  delete group['files']
  delete group['sortValue']

  return group
}

const getPreviousGroup = ([group, ...groups], index, prev = group) =>
  !group || group.index > index + 1
    ? prev
    : getPreviousGroup(groups, index, group)

export default connect(
  {
    items: mediaViewItems,
    isFetchingFiles: state`media.fetchId`,
    setActiveGroup: signal`media.setActiveGroup`,
    firstFetch: state`media.firstFetch`
  },
  class MediaView extends Component {
    constructor(props) {
      super(props)
      this.handleScroll = this.handleScroll.bind(this)
      this.setGroup({ index: 0, ...this.props.items[0] })
    }

    setGroup(nextGroup) {
      this.props.setActiveGroup({
        group: pruneGroupForState(nextGroup)
      })
      this.activeGroupIndex = nextGroup.index
    }

    componentWillReceiveProps(nextProps) {
      this.setGroup({ index: 0, ...nextProps.items[0] })
    }

    getMediaListComponent(row, key = null, style = {}) {
      if (row.type) return <Group item={row} key={key} style={style} />

      return (
        <div key={key} style={{ ...style, display: 'flex' }}>
          {row.map(file => <File path={file.path} key={file.path} />)}
        </div>
      )
    }

    rowRenderer(rows, { index, style, key, isVisible }) {
      return this.getMediaListComponent(rows[index], key, style)
    }

    onRowsRendered(groups, { startIndex, stopIndex }) {
      const nextGroup = getPreviousGroup(groups, startIndex)

      if (this.activeGroupIndex !== nextGroup.index) {
        this.activeGroupIndex = nextGroup.index
        this.props.setActiveGroup({ group: pruneGroupForState(nextGroup) })
      }
    }

    getRowCount({ width }) {
      const { files } = this.props
      const columnCount = this.getColumnCount({ width })
      return Math.ceil(files.length / columnCount)
    }

    getRowHeight(rows) {
      return ({ index }) => {
        if (rows[index].type === 'node')
          return (
            media.breadcrumb.dimensions.height +
            media.breadcrumb.dimensions.margin.top +
            media.breadcrumb.dimensions.margin.bottom
          )

        return (
          media.file.dimensions.height +
          media.file.dimensions.margin.top +
          media.file.dimensions.margin.bottom
        )
      }
    }

    handleScroll({ target }) {
      const { scrollTop, scrollLeft } = target
      this.List.Grid.handleScrollEvent({ scrollTop, scrollLeft })
    }

    structureRows(files, mediaPerRow) {
      if (!mediaPerRow) return []
      return files.reduce((acc, group) => {
        return [
          ...acc,
          { ...group },
          ...group.files.reduce((acc, file, index) => {
            const rowIndex = Math.floor(index / mediaPerRow)
            if (!acc[rowIndex]) acc[rowIndex] = []
            acc[rowIndex] = [...acc[rowIndex], file]
            return acc
          }, [])
        ]
      }, [])
    }

    render() {
      const { items, isFetchingFiles, firstFetch } = this.props

      const hasFiles = ([item, ...items]) => {
        if (!item) return false
        if (item.files.length) return true

        return hasFiles(items)
      }

      const content = !hasFiles(items) ? (
        <Empty
          Icon={EmptyFolder}
          translationKey={'bms.node.empty'}
          key={'emptyNode'}
        />
      ) : (
        <div key={'medias'} className={css(styles.contentWrapper)}>
          {isFetchingFiles && firstFetch ? (
            <div
              key={'loader'}
              style={{
                width: '100%',
                height: '70%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                zIndex: 100
              }}>
              <Loader fill={'#000'} />
            </div>
          ) : null}
          <AutoSizer>
            {({ width, height }) => {
              const rows = this.structureRows(
                items,
                Math.floor(
                  width /
                    (media.file.dimensions.width +
                      media.file.dimensions.margin.left +
                      media.file.dimensions.margin.right)
                )
              )

              const groupArr = rows.reduce((acc, row, index) => {
                const group = row.type ? { index, ...row } : null
                if (!group) return acc
                delete group['files']
                return [...acc, group]
              }, [])

              rows.splice(0, 1) // has to be done after creating groupArr

              return (
                <Scrollbars
                  autoHide
                  style={{ width, height }}
                  onScroll={this.handleScroll}>
                  <List
                    ref={instance => (this.List = instance)}
                    style={listStyle}
                    rowRenderer={props => {
                      return this.rowRenderer(rows, {
                        ...props,
                        width,
                        height
                      })
                    }}
                    onRowsRendered={this.onRowsRendered.bind(this, groupArr)}
                    height={height}
                    rowCount={rows.length}
                    overscanRowCount={10}
                    rowHeight={this.getRowHeight(rows)}
                    width={width}
                  />
                </Scrollbars>
              )
            }}
          </AutoSizer>
          <ContextMenu />
        </div>
      )

      return [<Strip key={'mediaStrip'} />, content]
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/Media/mediaView.js